import React, { useEffect, useState } from "react";
import "./InternetStatusOverlay.css";

const InternetStatusOverlay = () => {
    const [showPopup, setShowPopup] = useState(!navigator.onLine);

    useEffect(() => {
        const handleOnline = () => {
            setShowPopup(false);
        };

        const handleOffline = () => {
            setShowPopup(true);
        }

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    if (!showPopup) return null;

    return (
        <div className="overlay-backdrop">
            <div className="overlay-message">
                <div className="overlay-text">
                    You are currenly offline. Please check your internet connection.
                </div>
                <button className="overlay-button" onClick={() => setShowPopup(false)}>
                    Dismiss
                </button>
            </div>
        </div>
    );
};

export default InternetStatusOverlay;
